import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useTabelaHorariosOutletContext } from 'pages/TabelaHorario.context'
import { useParams } from 'react-router-dom'
import { tabelaHorarios } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirTabelaHorarios() {
    const { id } = useParams()
    const { data } = useTabelaHorariosOutletContext()
    const t = data.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = tabelaHorarios.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!t) return null

    const handleSubmit = () =>
        mutateAsync(t.id, {
            onSuccess: () => {
                toast.success('Tabela excluída com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'TabelaDeHorários']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={<>Realmente deseja excluir a tabela {t.nome}?</>}
        />
    )
}
